import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactHero = ({ onScrollToForm }) => {
  return (
    <section className="relative bg-gradient-to-br from-gray-50 to-blue-50 pt-24 pb-16 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-32 h-32 border-2 border-secondary rounded-brand transform rotate-12"></div>
        <div className="absolute top-40 right-20 w-24 h-24 border-2 border-primary rounded-brand transform -rotate-12"></div>
        <div className="absolute bottom-20 left-1/4 w-16 h-16 border-2 border-secondary rounded-brand transform rotate-45"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <div className="inline-flex items-center space-x-2 bg-secondary/10 text-secondary px-4 py-2 rounded-full text-sm font-medium">
                <Icon name="Zap" size={16} />
                <span>Start Your Digital Transformation</span>
              </div>
              
              <h1 className="text-4xl lg:text-5xl font-bold text-text-primary leading-tight">
                Let's Build Something
                <span className="text-gradient-brand block">Extraordinary Together</span>
              </h1>
              
              <p className="text-lg text-text-secondary leading-relaxed">
                From initial concept to production deployment, we're here to transform your vision into reality. 
                Get expert consultation, instant project insights, and immediate value—all in one conversation.
              </p>
            </div>

            {/* Quick Stats */}
            <div className="grid grid-cols-3 gap-6">
              <div className="text-center">
                <div className="text-2xl font-bold text-secondary">24h</div>
                <div className="text-sm text-text-secondary">Response Time</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-secondary">500+</div>
                <div className="text-sm text-text-secondary">Projects Delivered</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-secondary">98%</div>
                <div className="text-sm text-text-secondary">Client Satisfaction</div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                variant="default"
                size="lg"
                iconName="MessageCircle"
                iconPosition="left"
                className="cta-primary"
                onClick={onScrollToForm}
              >
                Start Consultation
              </Button>
            </div>
          </div>

          {/* Right Content - Contact Methods */}
          <div className="space-y-6">
            <div className="bg-white rounded-brand shadow-brand-card p-6 space-y-4">
              <h3 className="text-xl font-semibold text-text-primary">Get In Touch</h3>
              
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-secondary/10 rounded-brand flex items-center justify-center">
                    <Icon name="Mail" size={20} className="text-secondary" />
                  </div>
                  <div>
                    <div className="font-medium text-text-primary">Email</div>
                    <div className="text-text-secondary">sales@manicasolutions.com</div>
                  </div>
                </div>
                
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-secondary/10 rounded-brand flex items-center justify-center">
                    <Icon name="Phone" size={20} className="text-secondary" />
                  </div>
                  <div>
                    <div className="font-medium text-text-primary">Phone</div>
                    <div className="text-text-secondary">+27110836344</div>
                  </div>
                </div>
                
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-secondary/10 rounded-brand flex items-center justify-center">
                    <Icon name="MapPin" size={20} className="text-secondary" />
                  </div>
                  <div>
                    <div className="font-medium text-text-primary">Location</div>
                    <div className="text-text-secondary">Northgate, Randburg, Johannesburg</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Availability Widget */}
            <div className="bg-white rounded-brand shadow-brand-card p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-text-primary">Team Availability</h3>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                  <span className="text-sm text-text-secondary">Available Now</span>
                </div>
              </div>
              
              <div className="space-y-3">
                <div className="flex justify-between items-center">
                  <span className="text-sm text-text-secondary">Current Capacity</span>
                  <span className="text-sm font-medium text-text-primary">85%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div className="bg-secondary h-2 rounded-full" style={{ width: '85%' }}></div>
                </div>
                <div className="text-xs text-text-secondary">
                  Next available slot: Tomorrow 2:00 PM PST
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;